import { ref, reactive, watch } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7c472758"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 1,
  class: "record-wrap"
};
const _hoisted_2 = {
  class: "cardItem"
};
const _hoisted_3 = {
  class: "mr16"
};
const _hoisted_4 = {
  key: 1,
  class: "empty-font"
};
import { message } from "ant-design-vue";
import { useGoogleTaxManage } from "./useGoogleTaxManage";
import { editCountry } from "@/api/payManage/googleTax";
export default /*#__PURE__*/_defineComponent({
  __name: 'DetailModel',
  props: {
    open: {
      type: Boolean
    },
    detailInfList: null,
    currentDetailRecord: null
  },
  emits: ["handleCloseModel"],
  setup(__props, {
    emit
  }) {
    const props = __props;
    const current = ref(["detail"]);
    const formRef = ref(null);
    const menuItems = ref([{
      key: "detail",
      label: "详情"
    }, {
      key: "record",
      label: "变更记录"
    }]);
    const formData = reactive({
      countryInf: "",
      iosCode: "",
      currency: "",
      taxRate: 0,
      id: null
    });
    const rules = {
      countryInf: [{
        required: true,
        message: "请输入国家"
      }],
      currency: [{
        required: true
      }, {
        validator: (rule, value) => {
          if (!value) return Promise.resolve();
          const upperCasePattern = /^[A-Z]+$/;
          if (!upperCasePattern.test(value)) {
            return Promise.reject("币种只能输入英文大写字母");
          }
          return Promise.resolve();
        }
      }],
      taxRate: [{
        required: true,
        message: "请输入税率"
      }]
    };
    const {
      countryInfo,
      filterOption
    } = useGoogleTaxManage();
    watch(() => props.currentDetailRecord, newVal => {
      formData.countryInf = newVal.country;
      formData.iosCode = newVal.regionCode;
      formData.currency = newVal.currency;
      formData.taxRate = Number(newVal.taxRate);
      formData.id = newVal.id;
    });
    const handleChangeCountry = (value, option) => {
      if (value) {
        formData.iosCode = option.key;
      } else {
        formData.iosCode = "";
      }
    };
    const handleOk = () => {
      if (current.value[0] === "detail") {
        // 编辑
        formRef.value.validate().then(() => {
          editCountry({
            id: formData.id,
            currency: formData.currency,
            taxRate: String(formData.taxRate)
          }).then(res => {
            if (res.code === "0") {
              message.success('修改成功');
              handleCancel();
            }
          });
        });
      } else {
        handleCancel();
      }
    };
    const handleCancel = () => {
      current.value = ["detail"];
      emit("handleCloseModel");
    };
    return (_ctx, _cache) => {
      const _component_a_menu = _resolveComponent("a-menu");
      const _component_a_select_option = _resolveComponent("a-select-option");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_input_number = _resolveComponent("a-input-number");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_timeline_item = _resolveComponent("a-timeline-item");
      const _component_a_timeline = _resolveComponent("a-timeline");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: __props.open,
        onOk: handleOk,
        onCancel: handleCancel,
        maskClosable: false
      }, {
        default: _withCtx(() => [_createVNode(_component_a_menu, {
          selectedKeys: current.value,
          "onUpdate:selectedKeys": _cache[0] || (_cache[0] = $event => current.value = $event),
          mode: "horizontal",
          items: menuItems.value,
          class: "detail-menu"
        }, null, 8, ["selectedKeys", "items"]), current.value[0] === 'detail' ? (_openBlock(), _createBlock(_component_a_form, {
          key: 0,
          model: formData,
          ref_key: "formRef",
          ref: formRef,
          "label-col": {
            span: 4
          },
          "wrapper-col": {
            span: 14
          },
          style: {
            "margin-top": "25px"
          },
          rules: rules
        }, {
          default: _withCtx(() => [_createVNode(_component_a_form_item, {
            label: "国家：",
            name: "countryInf"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_select, {
              ref: "select",
              value: formData.countryInf,
              "onUpdate:value": _cache[1] || (_cache[1] = $event => formData.countryInf = $event),
              style: {
                "width": "100%"
              },
              placeholder: "请选择国家",
              "show-search": "",
              "allow-clear": "",
              disabled: true,
              "filter-option": _unref(filterOption),
              onChange: handleChangeCountry
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(countryInfo), item => {
                return _openBlock(), _createBlock(_component_a_select_option, {
                  key: item.regionCode,
                  value: item.country,
                  label: item.country
                }, {
                  default: _withCtx(() => [_createTextVNode(_toDisplayString(item.country), 1)]),
                  _: 2
                }, 1032, ["value", "label"]);
              }), 128))]),
              _: 1
            }, 8, ["value", "filter-option"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "ISO码："
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: formData.iosCode,
              "onUpdate:value": _cache[2] || (_cache[2] = $event => formData.iosCode = $event),
              disabled: true
            }, null, 8, ["value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "币种：",
            name: "currency"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              value: formData.currency,
              "onUpdate:value": _cache[3] || (_cache[3] = $event => formData.currency = $event)
            }, null, 8, ["value"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "税率：",
            name: "taxRate"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input_number, {
              style: {
                "width": "100%"
              },
              value: formData.taxRate,
              "onUpdate:value": _cache[4] || (_cache[4] = $event => formData.taxRate = $event),
              min: 0,
              precision: 2,
              formatter: value => `${value}%`,
              parser: value => value.replace('%', '')
            }, null, 8, ["value", "formatter", "parser"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])) : _createCommentVNode("", true), current.value[0] === 'record' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [__props.detailInfList.length > 0 ? (_openBlock(), _createBlock(_component_a_timeline, {
          key: 0,
          style: {
            "margin-top": "25px"
          }
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.detailInfList, (item, index) => {
            return _openBlock(), _createBlock(_component_a_timeline_item, {
              key: index
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_3, _toDisplayString(item.createDate), 1), _createElementVNode("span", null, "变更人：" + _toDisplayString(item.creator), 1)]), _createElementVNode("div", null, [_createElementVNode("span", null, _toDisplayString(item.msg), 1)])])]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 1
        })) : (_openBlock(), _createElementBlock("div", _hoisted_4, "暂无变更记录"))])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["open"]);
    };
  }
});